import { ISODateType, Timestamp } from '@principle-theorem/shared';

export interface ISetupWizardEmailContent {
  subject: string;
  body: string;
}

export interface ISetupWizardSmsContent {
  message: string;
}

export interface ISetupWizardStepInput {
  title: string;
  dueDate?: ISODateType;
}

export interface ISetupWizardDigestStepInput extends ISetupWizardStepInput {
  assigneeName?: string;
}

export interface ISetupWizardCompletedStepInput
  extends ISetupWizardDigestStepInput {
  completedAt?: Timestamp;
}

export interface IBaseEmailInput {
  recipientName: string;
  practiceName: string;
  wizardLink: string;
}

export interface IWelcomeEmailInput extends IBaseEmailInput {
  targetLaunchDate?: ISODateType;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ICompletionEmailInput extends IBaseEmailInput {}

export interface IAdminEscalationEmailInput {
  championName: string;
  assigneeName: string;
  practiceName: string;
  steps: ISetupWizardStepInput[];
  wizardLink: string;
  targetLaunchDate?: ISODateType;
}

export interface IAssignmentEmailInput extends IBaseEmailInput {
  steps: ISetupWizardStepInput[];
  targetLaunchDate?: ISODateType;
}

export interface IStepReminderSmsInput {
  stepCount: number;
  practiceName: string;
  wizardLink: string;
}

export interface IStepReopenedEmailInput extends IBaseEmailInput {
  stepTitle: string;
  targetLaunchDate?: ISODateType;
}

export interface IChampionDigestInput extends IBaseEmailInput {
  totalSteps: number;
  completedCount: number;
  completionPercentage: number;
  completedThisWeek: ISetupWizardCompletedStepInput[];
  overdueSteps: ISetupWizardDigestStepInput[];
  dueThisWeek: ISetupWizardDigestStepInput[];
  comingUpSteps: ISetupWizardDigestStepInput[];
  unscheduledSteps: Omit<ISetupWizardDigestStepInput, 'dueDate'>[];
  targetLaunchDate?: ISODateType;
  now: ISODateType;
}

export interface IAssigneeDigestInput extends IBaseEmailInput {
  openSteps: ISetupWizardStepInput[];
  overdueCount: number;
}
